import { Decoder, Encoder } from "@siteimprove/alfa-encoding";
import { URL } from "@siteimprove/alfa-url";
import { Headers } from "./headers.js";
/**
 * {@link https://fetch.spec.whatwg.org/#response-class}
 *
 * @public
 */
export class Response {
    static of(url, status, headers = Headers.empty(), body = new ArrayBuffer(0)) {
        return new Response(url, status, headers, body);
    }
    static _empty = Response.of(URL.blank(), 200);
    static empty() {
        return this._empty;
    }
    _url;
    _status;
    _headers;
    _body;
    constructor(url, status, headers, body) {
        this._url = url;
        this._status = status;
        this._headers = headers;
        this._body = body;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-response-url}
     */
    get url() {
        return this._url;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-response-status}
     */
    get status() {
        return this._status;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-response-headers}
     */
    get headers() {
        return this._headers;
    }
    /**
     * {@link https://fetch.spec.whatwg.org/#dom-body-body}
     */
    get body() {
        return this._body;
    }
    toJSON(options) {
        return {
            url: this._url.toString(),
            status: this._status,
            headers: this._headers.toJSON(options),
            body: Decoder.decode(new Uint8Array(this._body)),
        };
    }
    toEARL() {
        return {
            "@context": {
                http: "http://www.w3.org/2011/http#",
            },
            "@type": ["http:Message", "http:Response"],
            "http:statusCodeValue": this._status,
            "http:headers": this._headers.toEARL(),
            "http:body": {
                "@context": {
                    cnt: "http://www.w3.org/2011/content#",
                },
                "@type": ["cnt:Content", "cnt:ContentAsText"],
                "cnt:characterEncoding": "utf-8",
                "cnt:chars": Decoder.decode(new Uint8Array(this._body)),
            },
        };
    }
    toString() {
        let response = `HTTP/1.1 ${this._status}`;
        response += "\n" + this._headers.toString();
        response += "\n";
        response += Decoder.decode(new Uint8Array(this._body));
        return response;
    }
}
/**
 * @public
 */
(function (Response) {
    function from(json) {
        return URL.parse(json.url).map((url) => Response.of(url, json.status, Headers.from(json.headers), Encoder.encode(json.body)));
    }
    Response.from = from;
    function isResponse(value) {
        return value instanceof Response;
    }
    Response.isResponse = isResponse;
})(Response || (Response = {}));
//# sourceMappingURL=response.js.map